/**
 * File content-hub-pagination.js.
 * Handles submitting the pagination form
 * in the Content Hub pagination component.
 */

const paginationForm = document.querySelector('.content-hub-pagination__form');
const pageInput = document.querySelector('.content-hub-pagination__form-input');

function handlePageInput(e) {
  e.preventDefault();

  const page = parseInt(pageInput.value);
  if (isNaN(page) || page < pageInput.min || pageInput.max < page) {
    pageInput.value = pageInput.getAttribute('value');
    return;
  }
  const inputName = pageInput.name;
  const searchInput = this.querySelector('.content-hub-pagination__form-search'); 
  let dataLink = paginationForm.getAttribute('data-link');

  // strip search param from dataLink
  dataLink = dataLink.split('?')[0];

  let pagePath = '/';
  // if page, build page path
  if (page) {
    // single blog author navigation
    if (inputName == 'bapage') {
      pagePath = `?bapage=${page}`;
    } else {
      pagePath = `page/${page}/`;
    }
  } 

  // if search term, build search param
  const searchTerm = searchInput ? searchInput.value : false;
  const searchParam = searchTerm ? `?s=${searchTerm}` : '';

  // go to link + page + searchTerm
  window.location.href = `${dataLink}${pagePath}${searchParam}`;
}

// Inits
paginationForm?.addEventListener('submit', handlePageInput);

// Limit number input values
pageInput?.addEventListener('keydown', limitNumberInputValues);
